import axios from '../api'

const getCarReport = (data) => {
    return axios({
        url:`/api/app/report/monthly`,
        method:'post',
        data
    })
}
const getInformation = (params) => {
    return axios({
        url:`/api/plc/information`,
        method:'get',
        params
    })
}
const getInformationId = (informationId) => {
    return axios({
        url:`/api/plc/information/${informationId}`,
        method:'get',
    })
}

const doLogin = (params) => {
    return axios({
        url: `/api/wx/portal/bind/user`,
        method: 'get',
        params
    })
}

export default{
    getCarReport,
    getInformation,
    getInformationId,
    doLogin
}
